import React from 'react';
import {
    RunnerDetails,
    RunnerDetailsNumber,
    RunnerDetailsWrapper,
    RunnerNameAndPlace,
} from 'src/domains/sportsbook/webview/components/raceSummary/templates/runnerInfo/JockeyAndTrainerDetails.style';
import { observer } from 'src/utils/mobx-react';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';

interface JockeyAndTrainerDetailsType {
    selectionId: SelectionId;
    isDetailsAvailable: boolean;
    className?: string;
    textTruncate?: boolean;
}

export const JockeyAndTrainerDetails = observer(
    'JockeyAndTrainerDetails',
    (props: JockeyAndTrainerDetailsType): JSX.Element | null => {
        const { className, isDetailsAvailable, selectionId, textTruncate = true } = props;

        const selectionModel = selectionId.getModel();
        if (selectionModel === null) {
            return null;
        }

        if (selectionModel.name === '') {
            return null;
        }

        const jockey = (selectionModel.metaDataJockey ?? '').trim();
        const trainer = (selectionModel.metaDataTrainer ?? '').trim();
        const number = (selectionModel.metaDataNumber ?? '').trim();
        const drawn = (selectionModel.metaDataDrawn ?? '').trim();

        const horseNumber = ['', '0', '99'].includes(number) ? '' : number;
        const horseNumberAndName = horseNumber === '' ? selectionModel.name : `${horseNumber} ${selectionModel.name}`;

        return (
            <div className={className}>
                <RunnerNameAndPlace
                    data-test='runner-name'
                    title={horseNumberAndName}
                    textTruncate={textTruncate}
                >
                    {horseNumberAndName}
                </RunnerNameAndPlace>

                {isDetailsAvailable && (
                    <RunnerDetailsWrapper
                        data-test='runner-description'
                        textTruncate={textTruncate}
                    >
                        {drawn !== '' && <RunnerDetailsNumber>({drawn})</RunnerDetailsNumber>}
                        {jockey !== '' && <RunnerDetails title={jockey}>{jockey}</RunnerDetails>}
                        {trainer !== '' && <RunnerDetails title={trainer}>{trainer}</RunnerDetails>}
                    </RunnerDetailsWrapper>
                )}
            </div>
        );
    }
);
